export default __webpack_public_path__ + "images/7e4235f81340f31bbdf9a4c44d66888c.png";